import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withExperiments} from 'wix-experiments-react';
import get from 'lodash/get';
import serverApi from '../../services/serverApi';
import UploadBar from '../UploadBar/UploadBar';

class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: null
    };
  }

  componentWillReceiveProps(nextProps) { // todo check
    const {uploading} = this.props;
    if (!nextProps.uploading && uploading) {
      this.setDownloadUrlFromServer(nextProps.media);
    }
  }

  setDownloadUrlFromServer(media) {
    const {height, width, url} = media;
    const fillWidth = 200;
    const fillHeight = Math.floor(height * fillWidth / width);
    serverApi.getAttachment({url, width: fillWidth, height: fillHeight})
      .then(res => {
        const {url, resizedUrl} = res;
        this.setState({url, resizedUrl});
      });
  }

  componentDidMount() {
    const {media, uploading} = this.props;
    const {file} = media;

    if (file) {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.setState({
          imagePreviewUrl: reader.result
        });
      });
      reader.readAsDataURL(file);
    }

    if (!uploading) {
      this.setDownloadUrlFromServer(media);
    }
  }

  render() {
    const {uploading, chatSettings, media} = this.props;
    const {url, resizedUrl, imagePreviewUrl} = this.state;

    const imgStyle = {
      borderRadius: get(chatSettings, 'design.selectedRadiusOption') + 'px'
    };

    const img = <img src={imagePreviewUrl ? imagePreviewUrl : resizedUrl}/>;
    return url || imagePreviewUrl ? (
      <div className="image-container">
        <div className="image" style={imgStyle}>
          {uploading ? <span className="uploading"> {img} <UploadBar percentCompleted={media.percentCompleted}/> </span> : <a href={url} target="_blank" rel="noopener noreferrer">{ img }</a>}
        </div>
      </div>
      ) : null;
  }
}

Image.propTypes = {
  media: PropTypes.object,
  uploading: PropTypes.bool,
  chatSettings: PropTypes.object
};

function mapStateToProps(state) {
  return {
    chatSettings: state.chatSettings
  };
}

export default withExperiments(connect(mapStateToProps)(Image));



// WEBPACK FOOTER //
// ./chat-app/components/Image/Image.js